import DocumentHead from '@/components/document-head/DocumentHead'
import CustomizationsGridMemoed from '@/routes/customizations/CustomizationsGrid'
import { customizationsPageRouteLoader } from '@/routes/customizations/CustomizationsPage.route'
import { useCallback, useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useLoaderData } from 'react-router-typesafe'
import { Accordion, Item as AccordionItem, AccordionTypes } from 'devextreme-react/accordion'
import GenericFilterForm from '@/components/filter-form/GenericFilterForm'
import { FormFilterItemDescriptorType } from '@/components/filter-form/GenericFilterForm.types'
import { ButtonTypes } from 'devextreme-react/cjs/button'
const CustomizationsPage = () => {
  const title = 'Personalizzazioni'
  const { aziende, userInfo } = useLoaderData<typeof customizationsPageRouteLoader>()
  const { clientId } = useParams()
  const getFiltersConfiguration = useCallback((): FormFilterItemDescriptorType[] => {
    const fltConf: FormFilterItemDescriptorType[] = [
      {
        fieldName: 'azienda',
        placeHolder: 'Azienda',
        valueKeyName: 'id',
        valueDisplayExpr: 'nome',
        values: aziende.data.value,
        composeFilterItem(): any[] | null {
          if (this.currentValue === undefined || this.currentValue === null) return null
          return [['sede/azienda/id', this.currentValue]]
        },
      },
    ]
    console.log('GENFLT - GETCONF :', fltConf)
    return fltConf
  }, [aziende.data.value])

  const initialFilterConfiguration = useMemo(() => getFiltersConfiguration(), [getFiltersConfiguration])
  const [filterConfiguration, setFilterConfiguration] = useState(initialFilterConfiguration)
  const [filtersApplied, setFiltersApplied] = useState<boolean>(false)
  const getCurrentFilter = useCallback((): any[] => {
    let applied: boolean = false
    const currentFlts = []
    for (const flt of filterConfiguration) {
      const fltValue = flt.composeFilterItem()
      if (fltValue !== null) {
        currentFlts.push(fltValue)
      }
      if (!applied && flt.currentValue !== flt.defaultValue) applied = true
    }
    setFiltersApplied(applied)
    console.log('GENFLT - CURRENT:', currentFlts)
    return currentFlts
  }, [filterConfiguration])
  const [currentFilter, setCurrentFilter] = useState<any[]>(clientId ? [['sede/azienda/id', Number(clientId)]] : [])

  return (
    <>
      {!clientId && (
        <div className="accordion-generic-filter-form">
          <Accordion
            className={filtersApplied ? 'with-filter' : ''}
            collapsible={true}
            onContentReady={(e: AccordionTypes.ContentReadyEvent<any, any>) => {
              e.component?.collapseItem(0)
            }}
          >
            <AccordionItem icon="filter" title={'Filtri'}>
              <GenericFilterForm
                FormItemDescriptors={filterConfiguration}
                resetFilterClicked={function (e: ButtonTypes.ClickEvent): void {
                  setFilterConfiguration(getFiltersConfiguration())
                }}
                filterValueChanged={function (): void {
                  const currentFlts = getCurrentFilter()
                  console.log('GENFLT - VALUE CHNG', currentFlts)
                  if (JSON.stringify(currentFlts) !== JSON.stringify(currentFilter)) {
                    console.log('GENFLT - SETTING FILT', currentFlts)
                    setCurrentFilter(currentFlts)
                  }
                }}
              />
            </AccordionItem>
          </Accordion>
        </div>
      )}
      <CustomizationsGridMemoed currentFilter={currentFilter} userInfo={userInfo}></CustomizationsGridMemoed>
    </>
  )
}

export default CustomizationsPage
